module.exports = __webpack_public_path__ + "static/img/product9.58bcd55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product9.png
// module id = 8fOA
// module chunks = 10